import React from 'react';
import { Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import MarkdownContent from '../../../../components/MarkdownContent';
import { createSelectionRangeDescription, formatModifierPrice } from '../../services/modifiers';
import { MenuCatalogModifierSetPropType, MenuCatalogModifierPropType } from '../../types/menu-catalog';
import './ModifierSetGrid.css';
var defaultProps = {
  modifiers: [],
  displayDescription: false,
  displayMinMaxAllowed: false
};
export default function ModifierSetGrid(_ref) {
  var modifierSet = _ref.modifierSet,
    modifiers = _ref.modifiers,
    displayDescription = _ref.displayDescription,
    displayMinMaxAllowed = _ref.displayMinMaxAllowed;
  if (_isEmpty(modifiers) || _isEmpty(modifierSet)) {
    return null;
  }
  var minAllowed = modifierSet.minAllowed,
    maxAllowed = modifierSet.maxAllowed;
  var minMaxAllowedCopy = createSelectionRangeDescription(minAllowed, maxAllowed, {
    includeParenthesis: false
  });
  return /*#__PURE__*/React.createElement(Grid, {
    className: "modifier-set-grid"
  }, modifiers.map(function (modifier) {
    var modifierId = modifier._id,
      name = modifier.name,
      description = modifier.description,
      price = modifier.price;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "".concat(modifierId, "_").concat(name)
    }, /*#__PURE__*/React.createElement(Grid.Row, {
      className: "name-price"
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      width: 12,
      className: "name"
    }, name), /*#__PURE__*/React.createElement(Grid.Column, {
      width: 4,
      className: "price",
      textAlign: "right"
    }, formatModifierPrice(price, {
      noPriceLabel: '',
      displayZeroCost: false
    }))), displayDescription && !_isEmpty(description) && /*#__PURE__*/React.createElement(Grid.Row, {
      className: "description"
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      width: 16
    }, /*#__PURE__*/React.createElement(MarkdownContent, {
      content: description
    }))), displayMinMaxAllowed && !_isEmpty(minMaxAllowedCopy) && /*#__PURE__*/React.createElement(Grid.Row, {
      className: "min-max-allowed"
    }, /*#__PURE__*/React.createElement(Grid.Column, {
      width: 16
    }, minMaxAllowedCopy)));
  }));
}
ModifierSetGrid.defaultProps = defaultProps;